import React, { useEffect } from 'react';
import axios from 'axios';
import { domain } from '../common/domain';

function SubCategories() {
  const [subCategories, setSubCategories] = React.useState([]);
  const [newSubCategory, setNewSubCategory] = React.useState("");

  // Fetch subcategories on mount
  useEffect(() => {
    fetchSubCategories();
  }, []);

  const fetchSubCategories = async () => {
    try {
      const response = await axios.get(`${domain()}?endpoint=subcategories`);
      setSubCategories(response.data);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };

  const handleAddSubCategory = async () => {
    if (newSubCategory.trim()) {
      try {
        const formData = new FormData();
        formData.append("name", newSubCategory);
        // formData.append("category_id", 1); // Replace with dynamic category_id if needed

        await axios.post(`${domain()}?endpoint=subcategories`, formData);
        setNewSubCategory("");
        fetchSubCategories();
      } catch (error) {
        console.error("Error adding subcategory:", error);
      }
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${domain()}?endpoint=subcategories&id=${id}`);
      fetchSubCategories();
    } catch (error) {
      console.error("Error deleting subcategory:", error);
    }
  };

  const handleEdit = (index) => {
    const updatedSubCategories = subCategories.map((subCat, i) =>
      i === index ? { ...subCat, isEditing: !subCat.isEditing } : subCat
    );
    setSubCategories(updatedSubCategories);
  };

  const handleSave = async (id, name) => {
    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("_method", "PUT");
      await axios.post(`${domain()}?endpoint=subcategories&id=${id}&_method=PUT`, formData);
      fetchSubCategories();
    } catch (error) {
      console.error("Error updating subcategory:", error);
    }
  };

  const handleInputChange = (index, value) => {
    const updatedSubCategories = subCategories.map((subCat, i) =>
      i === index ? { ...subCat, name: value } : subCat
    );
    setSubCategories(updatedSubCategories);
  };

  return (
    <div className="p-3 bg-light text-dark rounded" style={{ maxWidth: '600px', margin: '0 auto' }}>
      <h5 className="mb-3 text-center">Subcategories</h5>
      <div className="d-flex mb-2">
        <input
          type="text"
          className="form-control form-control-sm me-2"
          placeholder="Subcategory name"
          value={newSubCategory}
          onChange={(e) => setNewSubCategory(e.target.value)}
        />
        <button className="btn btn-sm btn-primary" onClick={handleAddSubCategory}>
          Add
        </button>
      </div>
      <table className="table table-sm table-bordered text-center">
        <thead className="table-light">
          <tr>
            <th>#</th>
            <th>Subcategory</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {subCategories.length > 0 ? (
            subCategories.map((subCat, index) => (
              <tr key={subCat.id}>
                <td>{index + 1}</td>
                <td>
                  {subCat.isEditing ? (
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={subCat.name}
                      onChange={(e) => handleInputChange(index, e.target.value)}
                    />
                  ) : (
                    subCat.name
                  )}
                </td>
                <td>
                  {subCat.isEditing ? (
                    <button
                      className="btn btn-sm btn-success me-1"
                      onClick={() => handleSave(subCat.id, subCat.name)}
                    >
                      Save
                    </button>
                  ) : (
                    <button
                      className="btn btn-sm btn-warning me-1"
                      onClick={() => handleEdit(index)}
                    >
                      Edit
                    </button>
                  )}
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => handleDelete(subCat.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" className="text-muted">
                No subcategories found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default SubCategories;
